import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { StyledIconBase } from '@styled-icons/styled-icon';
export var SpeakerDeck = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var attrs = {
    "fill": "currentColor",
    "xmlns": "http://www.w3.org/2000/svg"
  };
  return /*#__PURE__*/React.createElement(StyledIconBase, _extends({
    iconAttrs: attrs,
    iconVerticalAlign: "middle",
    iconViewBox: "0 0 512 512"
  }, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M213.86 296H100a100 100 0 010-200h132.84a40 40 0 010 80H98c-26.47 0-26.45 40 0 40h113.82a100 100 0 010 200H40a40 40 0 010-80h173.86c26.48 0 26.46-40 0-40zM298 416a120.21 120.21 0 0051.11-80h64.55a19.83 19.83 0 0019.66-20V196a19.83 19.83 0 00-19.66-20H296.42a60.77 60.77 0 000-80h136.93c43.44 0 78.65 35.82 78.65 80v160c0 44.18-35.21 80-78.65 80z"
  }));
});
SpeakerDeck.displayName = 'SpeakerDeck';
export var SpeakerDeckDimensions = {
  height: 512,
  width: 512
};